import React from "react";
// State
// Components
import GuestPage from "../../Components/GuestPage";
import { ResetPasswordUsingToken } from "supertokens-auth-react/recipe/emailpassword/prebuiltui";

const ResetPassword = () => {
  return (
    <GuestPage>
      <ResetPasswordUsingToken />
    </GuestPage>
  );
};

export default ResetPassword;
